import TabButtonFilled from './component.jsx'
export default TabButtonFilled
